<template>
  <div id="ShippingCalender">
    <section>
      <div id="container">
        <div class="labelTitle lable">出荷カレンダー</div>
        <!--検索条件 -->
        <div class="result-area">
          <vc-calendar
            is-expanded
            style="width:100%; height: 100%;"
            :first-day-of-week="2"
            @update:from-page="changePage"
          >
            <template slot="header-title" slot-scope="page">{{page.yearLabel}}年{{page.monthLabel}}</template>
            <template slot="day-content" slot-scope="props">
              <div class="vc-border" is-expanded>
                <div style="border: 1px solid #ccc">
                  <div v-bind:style="addHolidaysStyle(props.day)">{{ props.day.day }}</div>
                </div>
                <div class="dayContents">
                  <ul>
                    <li>---在庫--------</li>
                    <template v-for="(kind, index) in kenshinDevice">
                      <li :key="props.day + kind + index">
                        <span :class="getType(kind)">{{getTypeName(kind)}}</span>
                        <span style="float:right;margin-right:10px;">{{getStock(getType(kind) ,props.day.day)}}台</span>
                      </li>
                    </template>
                    <!-- TODO ホルター実装
                    <template v-for="(kind, index) in holterDevice">
                      <li>
                        <span :class="getType(kind)">{{getTypeName(kind)}}</span>
                        <span style="float:right;margin-right:10px;">{{getStock(getType(kind) ,props.day.day)}}台</span>
                      </li>
                    </template>
                    -->
                    <li v-if="props.day.date >= today">---出荷予定----</li>
                    <li v-else>---出荷----</li>
                    <template v-for="(kind, index) in kenshinDevice">
                      <template v-for="(shipment, index2) of getShipment(getType(kind),props.day.day)">
                        <li :key="props.day + getType(kind) + index + 's' + index2">
                          <span style="display:inline-block;width:90px;overflow:hidden;white-space: nowrap;max-height:13px;">{{shipment.client}}</span>
                          <span :class="getType(kind)">{{getType(kind)}}</span>
                          <span style="float:right;margin-right:10px;">{{shipment.shipment}}台</span>
                        </li>
                      </template>
                    </template>
                    <li>&nbsp;</li>
                  </ul>
                </div>
              </div>
            </template>
          </vc-calendar>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {choicesType} from "@/components/mock/base/const.js";
const holiday_jp = require("@holiday-jp/holiday_jp");
const philipsHolidays = require('@/components/mock/base/philipsHollday.json')

export default {
  name: "ShippingCalender",
  methods: {
    changePage: function(event) {
      //祝日を更新する
      var sDate = new Date(event.year, event.month -1, 1)
      var eDate = new Date(event.year, event.month, 0)
      this.holidays = holiday_jp.between(sDate,eDate);
      //↓該当月の内容を更新する
      this.chengeList(sDate);
    },
    chengeList:function (sDate) {
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalShipmentCalendar.getShipmentCalendarPOST({
            body: {
              startDate: _this.yyyy_hyp_MM_hyp_dd(sDate)
            }
          });
        },
        function(result){
          _this.list = result.obj
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    addHolidaysStyle: function(day) {
      if (day.weekday == 1 || day.weekday == 7) {
        return {
          "background-color": "#ffbbff",
          "color": "red"
        };
      }
      var formatedDay = this.yyyy_hyp_MM_hyp_dd(day.date);
      for (var i in this.holidays) {
        if (
          formatedDay == this.yyyy_hyp_MM_hyp_dd(this.holidays[i].date)
        ) {
          return {
            "background-color": "#ffbbff",
            "color": "red"
          };
        }
      }
      //PHILIPS特別休日
      if(philipsHolidays.irregular.includes(formatedDay)){
          return {
            "background-color": "#ffbbff",
            "color": "red"
          };
      }
      //年末年始
      formatedDay = this.MM_hyp_dd(day.date);
      if(philipsHolidays.everyyear.includes(formatedDay)){
          return {
            "background-color": "#ffbbff",
            "color": "red"
          };
      }
      if(formatedDay== this.yyyy_hyp_MM_hyp_dd(new Date())){
          return {
            "background-color": "blue",
            "color": "white"
          };
      }

    },
    getStock: function(kind, day) {
      var day = this.list.find(item => {
        return item.day == day
      })

      if (day) {
        var kind = day.stock.find(item => {
          return item.kind == kind
        })
      }

      if (kind) {
        return kind.stock
      }

      return 0
    },
    getShipment: function(kind, day){
      var result = null

      var day = this.list.find(item => {
        return item.day == day
      })

      if (day) {
        var kind = day.ship.filter(item => {
          return item.kind == kind && item.client
        })

        if (kind.length > 0) {
          result = kind
        }
      }

      return result
    },
    getTypeName: function(kenshin){
      var ret = "";

      if (this.deviceKinds) {
        var device = this.deviceKinds.find(item => {
          return item.value == kenshin.value
        })

        if (device) {
          ret = device.kind
          if(ret){
            //「スリーププロファイラー」⇒「SP」
            //「スマートウォッチPMP300E」⇒「PMP300E」
            ret = ret.replace("スリーププロファイラー","SP").replace("スマートウォッチ","")
          }
        }
      }

      return ret;
    },
    getType: function(kenshin) {
      var ret = "";

      if (this.deviceKinds) {
        var device = this.deviceKinds.find(item => {
          return item.value == kenshin.value
        })

        if (device) {
          ret = device.abbreviation
        }
      }

      return ret;
    },
    pastDay: function(day) {
      return day.date < this.today;
    },
    getDeviceKinds: function(){
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalDeviceManagement.getDeviceKindsPOST({
            body:{}
          });
        },
        function(result){
          _this.deviceKinds = result.obj
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    getKenshinDevice: function(){
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getChoicesListPOST({
            body:{}
          });
        },
        function(result){
          var kenshin = result.obj.find(val => val.choicesType==_this.choicesType.kenshinDevice)
          var hst = result.obj.find(val => val.choicesType==_this.choicesType.hstKind)
          var holter = result.obj.find(val => val.choicesType==_this.choicesType.holterKind)
          kenshin = kenshin ? kenshin.choicesList : []
          var list = kenshin
          for(var i=0; i<hst.choicesList.length; i++){
            var item = hst.choicesList[i]
            item.label1 = item.label1.replace(/(【.*】)/g, "")
            // 機種名重複削除(ウォッチパット)
            var identicalName = list.find(v => v.label1==item.label1)
            if(!identicalName){
              list.push(item)
            }
            /* TODO ホルター実装
            else if(item.choicesType==_this.choicesType.holterKind){
              _this.holterDevice = item.choicesList;
            }
            */
          }
          var list = holter ? kenshin.concat(holter.choicesList) : kenshin
          _this.kenshinDevice = list
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
  },
  data() {
    var today = new Date()
    today = new Date(today.getFullYear(), today.getMonth(), today.getDate())
    return {
      holidays: [],
      list:[],
      today: today,
      kenshinDevice: null,
      deviceKinds: null,
      holterDevice: null,
      choicesType: choicesType
    };
  },
  filters: {},
  components: {},
  mounted: async function () {
    await this.getDeviceKinds();
    await this.getKenshinDevice();
  },
};
</script>
<style lang="scss" scoped>
  .opration-area {
    display:flex;
    justify-content:space-between;
  }
  .conditionTable {
    width:300px;
  }
  .dayContents {
    font-size: 0.7em;
    text-align: left;
    margin-left:10px;
    min-height:80px; 
  }
  ul {
    list-style:  none;
  }
  .vc-border {
    border-width: 0px !important;
  }
  .vc-grid-container {
    border-style:solid;
  }
  .WP, .PL, .PW, .SJ, .EP{
    font-weight: bold; 
  }
  .WP {
    color: darksalmon;
  }
  .PL {
    color: green;
  }
  .PW {
    color: blue;
  }
  .SJ {
    color: darksalmon;
  }
  .EP {
    color: green;
  }
  .SP, .SW {
    font-size: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/calender/ShippingCalender.vue